export default function (store) {
	if (process.env.CYPRESS_TEST === 'true') window.store = store;
}
